import useLayoutSettings from '@/hooks/theme/useLayoutSettings';
import styles from './styles.module.scss';

export default function CarousselBiggestWinsIcon() {
  const { isV3LayoutVariant } = useLayoutSettings();

  return (
    <div>
      {isV3LayoutVariant ? (
        <div className={`fa-solid fa-trophy ${styles.i}`} />
      ) : (
        <div className={styles.icon} />
      )}
    </div>
  );
}
